import { PermissionArrayItem, PermissionEnum } from "./TypesAndInterfaces";

export const permissionsArray : PermissionArrayItem[] = [
    {
      value: PermissionEnum.ADMIN,
      label: PermissionEnum.ADMIN,
      key: 0
    },
  { 
    value: PermissionEnum.MANAGE_SHOPS,
    label: PermissionEnum.MANAGE_SHOPS,
    key: 1
  },
  {
    value: PermissionEnum.VIEW_LOGS,
    label: PermissionEnum.VIEW_LOGS,
    key: 2
  },
  {
    value: PermissionEnum.VIEW_REPORTS,
    label: PermissionEnum.VIEW_REPORTS,
    key: 3
  }];